<div class="container-column section">
    <section>Orders</section>
</div>
<div class="card-container card" style="overflow-y: auto;">
    <form [formGroup]="form">
        <table style="margin-bottom: 5px;">
            <tr>
                <td>Project:</td>
                <td>
                    <kendo-dropdownlist class="dropdown" [data]="filteredProjects" textField="projectname"
                        valueField="projectId" [style.width.px]="395" formControlName="project"
                        [filterable]="true"
                        (filterChange)="onProjectFilter($event)"
                        (valueChange)="getObjectsForProjects($event)" [style.height.px]="30" [loading]="loading">
                    </kendo-dropdownlist>
                </td>
            </tr>
        </table>
    </form>
    <!-- <kendo-textbox [style.width.px]="width" placeholder="Search..." (valueChange)="onFilter($event)"></kendo-textbox> -->
    <kendo-grid class="content1" [kendoGridBinding]="portalObjects" kendoGridSelectBy="id" [(selectedKeys)]="selection"
        [selectable]="{ mode: 'single'}" [sortable]="true" [reorderable]="true" [resizable]="true"
        [columnMenu]="{ filter: true }" [loading]="loading1" (excelExport)="onExcelExport($event)">
        <ng-template kendoGridToolbarTemplate>
            <button type="button" class="allbuttons" kendoGridExcelCommand [svgIcon]="svgIcon[1]">
                Export
            </button>
        </ng-template>
        <kendo-grid-column field="name" title="Order No." [width]="120"></kendo-grid-column>
        <kendo-grid-column field="description" title="Order Description" [width]="170"></kendo-grid-column>
        <kendo-grid-column field="companyName" title="Company" [width]="200"></kendo-grid-column>
        <kendo-grid-column field="draftcount" title="Drafts" [width]="90">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span title="Clicking the count will navigate you to the Drafts tab."
                    style="cursor: pointer;color: #1825aa !important"
                    (click)="navigate('drafts', dataItem.draftcount, dataItem)">
                    {{ dataItem.draftcount }}
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="pendingcount" title="Pending Acknowledgement" [width]="190">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span title="Clicking the count will navigate you to the Submittals tab."
                    (click)="navigate('pending-acknowledgement', dataItem.pendingcount, dataItem)"
                    style="cursor: pointer;color: #1825aa !important">
                    {{ dataItem.pendingcount }}
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="uploadcount" title="All Submittals" [width]="115">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span style="cursor: pointer;color: #1825aa !important"
                    title="Clicking on the count will navigate you to the Submittals tab."
                    (click)="navigate('submittals', dataItem.uploadcount, dataItem)">
                    {{ dataItem.uploadcount }}
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="filecount" title="All Files" [width]="85">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span style="cursor: pointer;color: #1825aa !important"
                    title="Clicking on the count will navigate you to the Submittals tab."
                    (click)="navigate('submittals', dataItem.uploadcount, dataItem)"><!-- ask about navigation -->
                    {{ dataItem.filecount }}
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="maxuploaddate" title="Last Submittal Date" [width]="140" format="dd-MMM-yyyy">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.maxuploaddate | date:'dd-MMM-yyyy' }}
            </ng-template>
        </kendo-grid-column>
        <ng-template kendoGridNoRecordsTemplate>
            <div style="height: 273px;background-color: rgb(215 212 212 / 20%)">
                <kendo-svgicon [icon]="svgIcon[0]" size="xxxlarge"></kendo-svgicon>
                <p>There is no data to display here.
                </p>
            </div>
        </ng-template>
        <kendo-grid-excel [fileName]="getFileName()"></kendo-grid-excel>
    </kendo-grid>
</div>